<!--
 * @Author: 陈大仙人
 * @Date: 2020-10-09 18:15:51
 * @LastEditors: mn 1179443407@qq.com
 * @LastEditTime: 2023-01-06 19:39:06
 * @FilePath: /akx-datacloud-main/src/login/App.vue
-->
<template>
  <div id="mainApp">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: true,
    };
  },
  components: {},
  created() {

  },
  methods: {},
};
</script>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  line-height: 1;
}
#mainApp {
  background-color: #eeeeee;
  width: 100%;
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
  vertical-align: baseline;
  border: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial,
    sans-serif;
}
</style>
